import store from '../app/ReduxStore';
import reducer from '../app/Reducers';

/**
 * Generic redux dispatcher
 * @param payload object
 * @param payload.path string Path to the field to modify
 * @param payload.field string Field that you need to modify
 * @param payload.value any Value of the field
 */
export function dispatchUpdateData(payload) {
    store.dispatch({
        type: reducer.ACTION_TYPES.UPDATE_DATA,
        payload: payload
    });
}

export const PAGES = {
	CONDITIONS: 'conditions',
	DIRECT_DEPOSIT: 'direct_deposit',
	OFFER_ACCEPTANCE: 'offer_acceptance',
	FIRST_DAY: 'first_day',
	IS_UP: 'is_up',
};

export const REJECTION_REASON_FKS = {
	LOCATION: 18,
	OTHER: 3,
	SALARY: 4,
};

/**
 * Checks if UI components should be disabled because the user has either accepted or rejected the offer already.
 */
export function disableUI() {
	return store.getState().app.accepted || store.getState().app.rejected;
}

/**
 * Shows a message to the user.
 * @param title The message title
 * @param message The message to show
 * @param icon (optional) The icon to use in the message box
 */
export function showMessage(title, message, icon = undefined) {
	const newMessage = {
		title: title,
		message: message,
		icon: icon
	};
	dispatchUpdateData({field: 'messages', value: store.getState().messages.concat(newMessage)});
}